import { type MouseEvent, useRef } from 'react';

/** Смещение курсора, после которого перетаскивание считается листанием, px */
const SWIPE_THRESHOLD = 40;

interface IUseMouseSwipeParams {
  onPrev(): void;
  onNext(): void;
}

/**
 * Листание фото перетаскиванием мышью, как в fotorama монолита.
 * Клик после листания гасится, чтобы перетаскивание не считалось нажатием
 */
export function useMouseSwipe({ onPrev, onNext }: IUseMouseSwipeParams) {
  const startXRef = useRef<number | null>(null);
  const isSwipedRef = useRef(false);

  return {
    onMouseDown: (event: MouseEvent) => {
      startXRef.current = event.clientX;
      isSwipedRef.current = false;
    },
    onMouseUp: (event: MouseEvent) => {
      if (startXRef.current === null) {
        return;
      }

      const deltaX = event.clientX - startXRef.current;
      startXRef.current = null;

      if (Math.abs(deltaX) >= SWIPE_THRESHOLD) {
        isSwipedRef.current = true;
        if (deltaX < 0) {
          onNext();
        } else {
          onPrev();
        }
      }
    },
    onMouseLeave: () => {
      startXRef.current = null;
    },
    onClickCapture: (event: MouseEvent) => {
      if (isSwipedRef.current) {
        isSwipedRef.current = false;
        event.stopPropagation();
        event.preventDefault();
      }
    },
    /** Иначе браузер тащит саму картинку вместо листания */
    onDragStart: (event: MouseEvent) => event.preventDefault(),
  };
}
